import{IconDash75 as e}from"../src/elements/IconDash75.js";customElements.define("sp-icon-dash75",e);
//# sourceMappingURL=sp-icon-dash75.js.map
